'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const pending = [
{
  id: 'pv-fatima', name: 'Fatima Zahra Boudali', handle: '@fz.boudali', category: 'Family · Lifestyle',
  city: 'Tlemcen', followers: '18K', engagement: 15.6, submittedAt: 'Il y a 1h',
  waitHours: 1, docs: 3,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_199a7fdbc-1784020395816.png",
  avatarAlt: 'Fatima Zahra Boudali pending verification'
},
{
  id: 'pv-imane', name: 'Imane Kaci', handle: '@imane.kaci', category: 'Beauty · UGC',
  city: 'Blida', followers: '22K', engagement: 14.8, submittedAt: 'Il y a 3h',
  waitHours: 3, docs: 4,
  avatar: "https://images.unsplash.com/photo-1695133134040-2eb96e5fe8e6",
  avatarAlt: 'Imane Kaci pending verification'
},
{
  id: 'pv-omar', name: 'Omar Hadjadj', handle: '@omar.edu', category: 'Education',
  city: 'Sétif', followers: '31K', engagement: 11.2, submittedAt: 'Il y a 6h',
  waitHours: 6, docs: 2,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_172c85b34-1765716220609.png",
  avatarAlt: 'Omar Hadjadj pending verification'
},
{
  id: 'pv-mehdi', name: 'Mehdi Terki', handle: '@mehdi.sport', category: 'Sport',
  city: 'Annaba', followers: '27K', engagement: 10.4, submittedAt: 'Il y a 52h',
  waitHours: 52, docs: 2,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16ec2395c-1764717466184.png",
  avatarAlt: 'Mehdi Terki pending verification'
},
{
  id: 'pv-leila', name: 'Leila Amrani', handle: '@leila.travel', category: 'Travel · Lifestyle',
  city: 'Béjaïa', followers: '14K', engagement: 12.1, submittedAt: 'Il y a 72h',
  waitHours: 72, docs: 3,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1168b8529-1773117569822.png",
  avatarAlt: 'Leila Amrani pending verification'
}];


export default function PendingVerifications() {
  const [items, setItems] = useState(pending);
  const [processing, setProcessing] = useState<string | null>(null);

  const handleAction = (id: string, action: 'approve' | 'reject') => {
    setProcessing(id);
    setTimeout(() => {
      setItems((prev) => prev.filter((p) => p.id !== id));
      setProcessing(null);
    }, 800);
  };

  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-700 text-foreground">Vérifications en attente</h3>
        <span className="bg-warning/15 text-warning text-xs font-700 px-2 py-0.5 rounded-full border border-warning/20">
          {items.length} en attente
        </span>
      </div>

      {items.length === 0 ?
      <div className="flex flex-col items-center py-8 text-center">
          <Icon name="CheckCircleIcon" size={32} className="text-positive mb-2" />
          <p className="text-sm font-600 text-foreground">Tout est à jour</p>
          <p className="text-xs text-muted-foreground mt-1">Aucune vérification en attente</p>
        </div> :

      <div className="space-y-3">
          {items.map((item) =>
        <div
          key={item.id}
          className={`border rounded-xl p-4 transition-all ${
          item.waitHours >= 48 ?
          'border-negative/30 bg-negative/5' : 'border-border bg-muted/30'}`
          }>
          
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 rounded-full overflow-hidden border border-border flex-shrink-0">
                  <AppImage src={item.avatar} alt={item.avatarAlt} width={36} height={36} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-700 text-foreground">{item.name}</p>
                  <p className="text-xs text-muted-foreground">{item.handle} · {item.category}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-muted-foreground">{item.city}</span>
                    <span className="text-xs font-mono text-foreground">{item.followers}</span>
                    <span className="text-xs text-positive font-600">{item.engagement}%</span>
                  </div>
                </div>
                {item.waitHours >= 48 &&
            <span className="flex-shrink-0">
                    <Icon name="ExclamationTriangleIcon" size={14} className="text-negative" />
                  </span>
            }
              </div>

              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <Icon name="ClockIcon" size={12} className="text-muted-foreground" />
                  <span className={`text-xs ${item.waitHours >= 48 ? 'text-negative font-600' : 'text-muted-foreground'}`}>
                    {item.submittedAt}
                  </span>
                  <span className="text-xs text-muted-foreground">· {item.docs} docs</span>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
              onClick={() => handleAction(item.id, 'approve')}
              disabled={processing === item.id}
              className="flex-1 flex items-center justify-center gap-1.5 bg-positive/15 hover:bg-positive/25 text-positive text-xs font-700 py-2 rounded-lg transition-all active:scale-95 disabled:opacity-60">
              
                  {processing === item.id ?
              <Icon name="ArrowPathIcon" size={12} className="animate-spin" /> :

              <Icon name="CheckIcon" size={12} />
              }
                  Approuver
                </button>
                <button
              onClick={() => handleAction(item.id, 'reject')}
              disabled={processing === item.id}
              className="flex-1 flex items-center justify-center gap-1.5 bg-negative/10 hover:bg-negative/20 text-negative text-xs font-700 py-2 rounded-lg transition-all active:scale-95 disabled:opacity-60">
              
                  <Icon name="XMarkIcon" size={12} />
                  Refuser
                </button>
              </div>
            </div>
        )}
        </div>
      }
    </div>);

}